<template>
	<div @mouseenter="onEnter" @onmouseleave="onLeave" @click="onClick">
		<slot />
	</div>
</template>

<script setup lang="ts">
import { useTelemetry } from '@/features/telemetry/useTelemetry'

const { trackEvent } = useTelemetry()

const props = withDefaults(
	defineProps<{
		name: string
		events?: Array<'click' | 'hover'>
	}>(),
	{
		events: () => ['click']
	}
)

function onEnter() {
	if (props.events.includes('hover')) {
		trackEvent('user', 'Hovered over an element', { name: props.name })
	}
}

function onLeave() {
	if (props.events.includes('hover')) {
		trackEvent('user', 'Moved away from an element', { name: props.name })
	}
}

function onClick() {
	if (props.events.includes('click')) {
		trackEvent('user', 'Clicked on an element', { name: props.name })
	}
}
</script>
